type GetObjectFromValue = (
  value: string | number | undefined,
  list: Option[] | undefined
) => Option | "" | undefined;

export const getObjectFromValue: GetObjectFromValue = (value, list = []) => {
  return value ? list.find((option) => option.value === value) : "";
};
